module.exports = __webpack_public_path__ + "img/yoga.e3c42cbe.png";